import { createActorContext } from '@xstate/react';
import { machine } from './definition';

export const StateMachineContext = createActorContext(machine);
